/**
 * Вычисляет с какой позиции элементы в меню начинают скрываться.
 * @param {number} navWidth Ширина контейнера
 * @param {number[]} itemsWidth Массив с шириной каждого элемента меню
 * @returns {number}
 */
export default function calcStartHideIndex(navWidth, itemsWidth, hideIndex) {
  const menuItemsWidth = itemsWidth.slice(1);
  const moreWidth = itemsWidth[0];

  const itemsSum = itemsWidth.reduce((sum, current) => sum + current, 0);

  let startHideIndex = hideIndex;

  /**
   * Расчитываем доступную ширину меню с учетом кнопки "Еще"
   */
  const availableNavWidth = itemsSum >= navWidth
    ? navWidth - moreWidth
    : navWidth;

  let sum = 0;
  menuItemsWidth.some((item, i) => {
    sum = sum + item;
    if (sum >= availableNavWidth) {
      startHideIndex = i;
      return true;
    }
    return false;
  });

  return startHideIndex;
}
